import { motion } from 'motion/react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { useUIStore } from '../../stores/uiStore';
import { UploadModal } from '../files/UploadModal';
import { CreateFolderModal } from '../files/CreateFolderModal';
import clsx from 'clsx';

interface MainLayoutProps {
  children: React.ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  const isSidebarCollapsed = useUIStore((s) => s.isSidebarCollapsed);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-slate-950 transition-colors">
      <Header />

      <div className="flex pt-16">
        <Sidebar />

        <motion.main
          layout
          className={clsx(
            'flex-1 min-h-[calc(100vh-4rem)] transition-all duration-300',
            isSidebarCollapsed ? 'ml-16' : 'ml-64'
          )}
        >
          <div className="p-6">{children}</div>
        </motion.main>
      </div>

      {/* Global Modals */}
      <UploadModal />
      <CreateFolderModal />
    </div>
  );
}
